enum UserRole {
  MEMBER = 'member',
  CURATOR = 'curator',
  ADMIN = 'admin',
  PENDING = 'pending',
}

export default UserRole;
